import Loader from 'components/partials/loader/loader';
import Heading from 'components/partials/heading/heading';
import EmptySpaceContent from 'components/partials/empty-space-content/empty-space-content';
import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';
import FavoriteReportTile from './farovite-report-tile/farovite-report-tile';

import { useFavoriteReports } from 'hooks/api/use-favorite-reports';

import useProductTypesDictionary from '../use-product-types-dictionary';

import type { FavoriteReportData } from './farovite-report-tile/farovite-report-tile';

const FavoriteReports = (): React.JSX.Element => {
  const { dictionary: productTypesDictionary } = useProductTypesDictionary();
  const { data: favoriteReports, loading } = useFavoriteReports();

  const favoriteReportsList = favoriteReports as
    | FavoriteReportData[]
    | null
    | undefined;

  return (
    <ResponsiveWrapper customClass="py-4 px-6">
      <Heading variant="h1">Favorites</Heading>

      <div className="mt-5">
        {!favoriteReportsList?.length && !loading && (
          <EmptySpaceContent
            customClass="h-[55vh]"
            text="You don't have any favorites saved yet. Navigate to reports to create your first favorite!"
          />
        )}

        {loading ? (
          <Loader loading customClass="!bg-transparent" />
        ) : (
          <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {favoriteReportsList?.map((favoriteReport) => (
              <FavoriteReportTile
                key={favoriteReport.id}
                favoriteReport={favoriteReport}
                productTypesDictionary={productTypesDictionary}
              />
            ))}
          </div>
        )}
      </div>
    </ResponsiveWrapper>
  );
};

export default FavoriteReports;
